import { Component, Input, OnChanges } from '@angular/core';
import { SmsEncodingService } from '../../data/services/utilities/sms-encoding.service';

/**
 * Componente de contador de caracteres SMS con sanitización visual
 * Muestra longitud actual, caracteres sanitizados y advertencias
 */
@Component({
  selector: 'app-sms-character-counter',
  templateUrl: './sms-character-counter.component.html',
  styleUrls: ['./sms-character-counter.component.scss']
})
export class SmsCharacterCounterComponent implements OnChanges {
  @Input() message: string = '';
  
  sanitizedMessage: string = '';
  sanitizedLength: number = 0;
  incompatibleChars: string[] = [];
  wasSanitized: boolean = false;
  wasTruncated: boolean = false;

  readonly MAX_LENGTH = 160;

  constructor(private smsEncodingService: SmsEncodingService) {}

  ngOnChanges() {
    this.updateAnalysis();
  }

  private updateAnalysis() {
    if (!this.message) {
      this.sanitizedMessage = '';
      this.sanitizedLength = 0;
      this.incompatibleChars = [];
      this.wasSanitized = false;
      this.wasTruncated = false;
      return;
    }

    // Sanitizar
    this.sanitizedMessage = this.smsEncodingService.sanitizeToGSM7(this.message);
    this.wasSanitized = this.message !== this.sanitizedMessage;
    
    // Detectar truncado
    this.wasTruncated = this.sanitizedMessage.length > this.MAX_LENGTH;
    
    // Truncar si excede
    if (this.wasTruncated) {
      this.sanitizedMessage = this.smsEncodingService.truncateToSingleSms(this.sanitizedMessage);
    }
    
    this.sanitizedLength = this.sanitizedMessage.length;
    this.incompatibleChars = this.smsEncodingService.getIncompatibleChars(this.message);
  }

  get statusClass(): string {
    const percent = (this.sanitizedLength / this.MAX_LENGTH) * 100;
    
    if (this.wasTruncated) return 'error';
    if (percent > 90) return 'warning';
    return 'success';
  }

  get statusIcon(): string {
    if (this.wasTruncated) return 'pi-exclamation-triangle';
    if (this.sanitizedLength > this.MAX_LENGTH * 0.9) return 'pi-info-circle';
    return 'pi-check-circle';
  }

  get remainingChars(): number {
    return Math.max(0, this.MAX_LENGTH - this.sanitizedLength);
  }
}
